<label class="ui-g-5 field-label text-right-align fix-label-position" [ngClass]="{ required: isRequired }">
  {{ label }}
</label>
<div class="control-wrapper" *ngIf="'app.calendar-settings' | translate as locale">
  <p-calendar
    tabIndex="0"
    appCalendarEscapeClose
    [locale]="locale"
    [dateFormat]="dateFormat.dateFormat"
    [placeholder]="dateFormat.placeholder"
    [monthNavigator]="true"
    [yearNavigator]="true"
    [name]="name"
    class="doc-submit-datepicker"
    dateFormat="string"
    inputId="basic"
    yearRange="2023:2080"
    [(ngModel)]="selectedValue"
    (ngModelChange)="selectValue($event)"
    [disabled]="control.disabled || forceDisable"></p-calendar>
</div>
